<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-12">
              {{ title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row pl-2">
            <td class="col-md-12 pl-3 text-left">
              <div v-for="item in items" :key="item.id + ' ' + item.answer">
                <CustomFormQuestion
                  :submitted="submitted"
                  :resolution="mode === 'resolution'"
                  :question="item"
                  :show-display-number="showDisplayNumber"
                  :visible="isVisible(item)"
                  :required="required"
                  @updateParentQuestion="updateParentQuestion"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CustomFormQuestion from '@/components/pei/CustomFormQuestion';

export default {
  name: 'ControversyList',
  props: {
    title: {
      type: String,
      default: () => '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    showDisplayNumber: {
      type: Boolean,
      default: () => true,
    },
    mode: {
      type: String,
      default: () => 'controversy',
    },
    submitted: {
      type: Boolean,
      default: () => false,
    },
    required: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      showComment: false,
      StatusComment: [],
      models: [],
    };
  },
  methods: {
    questionChange(e) {
      let self = this;
      self.$emit('on-change-question', { isYes: e.selectedAnswer });
      self.changeStatus(e.number, e.selectedAnswer);
    },
    changeStatus(indxVal, SelectedAnswer) {
      let self = this;
      if (SelectedAnswer) {
        self.StatusComment.push({ Id: indxVal, Value: true });
      } else {
        let indx = self.StatusComment.findIndex((elem) => elem.Id == indxVal);

        if (indx >= 0) {
          self.StatusComment.splice(indx, 1);
        }
      }
    },
    updateParentQuestion(answer) {
      this.items[1].parentQuestion.relatedValue = answer;
      this.items[2].parentQuestion.relatedValue = answer;

      if (answer === false) {
        this.items[1].answer = null;
        this.items[2].answer = null;
      }
    },
    isVisible(question) {
      let result = true;

      if (question && question.parentQuestion) {
        if (
          question.parentQuestion.relatedValue === null ||
          question.parentQuestion.relatedValue === false
        ) {
          result = false;
        }
      }

      return result;
    },
  },
  components: {
    CustomFormQuestion,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.container-form {
  background: #f4f6f3;
  margin: 10px 250px 10px 70px;
}

.custom-question-class >>> .custom-checkbox {
  display: inline;
}
</style>
